/* Actions */
// export const NAVIGATE_TO_SEARCH_PAGE = "NAVIGATE_TO_SEARCH_PAGE";
export const CHECK_FILTER_MODELS_UPDATED = "CHECK_FILTER_MODELS_UPDATED";
export const CHECK_FILTER_MODELS_DEFAULTED = "CHECK_FILTER_MODELS_DEFAULTED";
export const POPULATE_FILTER_OPTIONS = "POPULATE_FILTER_OPTIONS";
export const APPLY_FILTER_MODELS = "APPLY_FILTER_MODELS";
export const REQUEST_NEW_VISITOR_SEARCH_SCORING =
  "REQUEST_NEW_VISITOR_SEARCH_SCORING";
/* Mutations */
export const SET_LOADING = "SET_LOADING";
export const SET_LOADED = "SET_LOADED";
export const SET_PAGE = "SET_PAGE";
export const SET_FILTER_OPTIONS = "SET_FILTER_OPTIONS";
export const SET_PAGINATION_TOTALS = "SET_PAGINATION_TOTALS";
export const SET_STATE_FROM_QUERY_PARAM = "SET_STATE_FROM_QUERY_PARAM";
export const RESET_PAGINATION = "RESET_PAGINATION";
export const SET_SORT = "SET_SORT";
export const SET_FILTER_MODELS_FROM_KEYWORD = "SET_FILTER_MODELS_FROM_KEYWORD";
export const SET_URL_PARAMS = "SET_URL_PARAMS";
export const SET_LOCATION = "SET_LOCATION";
export const SET_FEATURES_FILTER_OPTIONS_LOADING =
  "SET_FEATURES_FILTER_OPTIONS_LOADING";
// New mutations for direct search object manipulation
export const SET_SEARCH_FILTERS = "SET_SEARCH_FILTERS";
export const ADD_SEARCH_FILTER = "ADD_SEARCH_FILTER";
export const REMOVE_SEARCH_FILTER = "REMOVE_SEARCH_FILTER";
export const UPDATE_SEARCH_FILTER = "UPDATE_SEARCH_FILTER";
export const SET_SEARCH_OPTIONS = "SET_SEARCH_OPTIONS";
export const SET_SEARCH_SORTING = "SET_SEARCH_SORTING";
export const SET_SEARCH_SCORING = "SET_SEARCH_SCORING";
export const ADD_SEARCH_SCORING = "ADD_SEARCH_SCORING";
export const REMOVE_SEARCH_SCORING = "REMOVE_SEARCH_SCORING";
export const UPDATE_SEARCH_SCORING = "UPDATE_SEARCH_SCORING";
export const SYNC_STANDARDIZED_STATE = "SYNC_STANDARDIZED_STATE";
export const REMOVE_COMPLEX_FILTERS = "REMOVE_COMPLEX_FILTERS";
